import { useEffect, useRef, useState } from "react";

export function Cursor() {
  const dotRef = useRef<HTMLDivElement>(null);
  const ringRef = useRef<HTMLDivElement>(null);
  const [isHovering, setIsHovering] = useState(false);
  const [isClicking, setIsClicking] = useState(false);
  const pos = useRef({ x: 0, y: 0 });
  const ringPos = useRef({ x: 0, y: 0 });
  const rafRef = useRef<number>(0);

  useEffect(() => {
    const onMove = (e: MouseEvent) => {
      pos.current = { x: e.clientX, y: e.clientY };
    };

    const onDown = () => setIsClicking(true);
    const onUp = () => setIsClicking(false);

    const addHover = () => {
      const els = document.querySelectorAll("a, button, [data-cursor-hover]");
      els.forEach((el) => {
        el.addEventListener("mouseenter", () => setIsHovering(true));
        el.addEventListener("mouseleave", () => setIsHovering(false));
      });
    };

    const animate = () => {
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${pos.current.x}px, ${pos.current.y}px)`;
      }
      ringPos.current.x += (pos.current.x - ringPos.current.x) * 0.12;
      ringPos.current.y += (pos.current.y - ringPos.current.y) * 0.12;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ringPos.current.x}px, ${ringPos.current.y}px)`;
      }
      rafRef.current = requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mousedown", onDown);
    window.addEventListener("mouseup", onUp);
    addHover();
    rafRef.current = requestAnimationFrame(animate);

    const observer = new MutationObserver(addHover);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mousedown", onDown);
      window.removeEventListener("mouseup", onUp);
      cancelAnimationFrame(rafRef.current);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      {/* Dot */}
      <div
        ref={dotRef}
        className="fixed top-0 left-0 pointer-events-none z-[9999]"
        style={{
          width: isClicking ? "6px" : "8px",
          height: isClicking ? "6px" : "8px",
          background: "#22d3ee",
          borderRadius: "50%",
          marginLeft: isClicking ? "-3px" : "-4px",
          marginTop: isClicking ? "-3px" : "-4px",
          transition: "width 0.1s, height 0.1s, margin 0.1s, background 0.2s",
          mixBlendMode: "difference",
        }}
      />
      {/* Ring */}
      <div
        ref={ringRef}
        className="fixed top-0 left-0 pointer-events-none z-[9998]"
        style={{
          width: isHovering ? "56px" : isClicking ? "28px" : "36px",
          height: isHovering ? "56px" : isClicking ? "28px" : "36px",
          border: `1.5px solid ${isHovering ? "#a78bfa" : "#22d3ee"}`,
          borderRadius: "50%",
          marginLeft: isHovering ? "-28px" : isClicking ? "-14px" : "-18px",
          marginTop: isHovering ? "-28px" : isClicking ? "-14px" : "-18px",
          opacity: 0.7,
          transition: "width 0.3s ease, height 0.3s ease, margin 0.3s ease, border-color 0.3s ease",
          mixBlendMode: "difference",
        }}
      />
    </>
  );
}
